import { Navigate, useLocation } from 'react-router-dom'

export function LegacyAccountingRedirect() {
  const { pathname, search, hash } = useLocation()
  const nextPath =
    pathname === '/dashboard' ? '/accounting' : `/accounting${pathname}`

  return <Navigate to={{ pathname: nextPath, search, hash }} replace />
}
